import { Grid } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { ContractImportationStore as Store } from "store";
import {
  CompletedLayer,
  ErrorLayer,
  LoadingLayer,
  ProgressLayer,
} from "./Layers";

import { lang } from "i18nLang";

interface IProps {
  isloading: boolean;
  type: string;
  onCloseByError: Function;
  onCloseByComplete: Function;
}

const ProcessingLayers = observer((props: IProps) => {
  const { importStatus, importProgress, importTimeLeft } = Store;
  const importError = Store.error;
  const importationHasError = Store.importationHasError();

  if (importationHasError)
    return (
      <Grid style={{ padding: "3rem 0 5rem 0" }}>
        <ErrorLayer
          onClose={props.onCloseByError}
          title={lang(`importation.${props.type}.status.error`)}
          message={importError.message}
          details={importError.detail}
        />
      </Grid>
    );

  if (props.isloading)
    return (
      <Grid style={{ padding: "6rem 0 15rem 0" }}>
        <LoadingLayer
          message={lang(`importation.${props.type}.status.${importStatus}`)}
        />
      </Grid>
    );

  return (
    <Grid style={{ padding: "3rem 0 5rem 0" }}>
      {importProgress < 100 ? (
        <ProgressLayer
          progress={importProgress}
          message={lang(`importation.${props.type}.status.${importStatus}`)}
          detailMessage={lang(`importation.${props.type}.processingMessage`)}
          timeLeft={importTimeLeft}
        />
      ) : (
        <CompletedLayer
          onClose={props.onCloseByComplete}
          message={lang(`importation.${props.type}.status.${importStatus}`)}
          detailMessage={lang(`importation.${props.type}.processedMessage`)}
        />
      )}
    </Grid>
  );
});

export default ProcessingLayers;
